import { render, staticRenderFns } from "./liveContent.vue?vue&type=template&id=5555b404&scoped=true"
import script from "./liveContent.vue?vue&type=script&lang=js"
export * from "./liveContent.vue?vue&type=script&lang=js"
import style1 from "./liveContent.vue?vue&type=style&index=1&id=5555b404&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5555b404",
  null
  
)

export default component.exports